import React, { PureComponent } from 'react'
import asyncComponent from './asyncComponent'
import verifyToken from '../helpers/verifyToken'

const authProtection = ComposedComponent =>
  asyncComponent(() => verifyToken().then(() => ComposedComponent))

export default authProtection



// WEBPACK FOOTER //
// ./src/HOCs/authProtection.js